import { Collection } from 'modules/core/lib/mobx-rest'

import PolicyPeriod from 'modules/payroll_bundle/store/models/PolicyPeriod'

export class PolicyPeriods extends Collection<PolicyPeriod> {
  get cacheKey(): string {
    return 'policyPeriods'
  }

  get indexes() {
    return ['policy_id']
  }

  model() {
    return PolicyPeriod
  }

  async createNextForPolicy(policyId?: string): Promise<PolicyPeriod> {
    const value = await this.rpc('create_next_for_policy', {
      policy_id: policyId,
    })
    this.add(value)

    return value
  }

  async createPreviousForPolicy(policyId?: string): Promise<PolicyPeriod> {
    const value = await this.rpc('create_previous_for_policy', {
      policy_id: policyId,
    })
    this.add(value)

    return value
  }
}

const singleton = new PolicyPeriods()

export default singleton
